// react
import PropTypes from "prop-types";
import React from "react";

// constants
import Colors from "../../constants/Colors";
// styles
import css from "./Spinner.module.scss";

/**
 * @deprecated Use the Spinner component from the py-components package instead
 */
export default class Spinner extends React.PureComponent {
	static propTypes = {
		centered: PropTypes.bool,
		size: PropTypes.number,
		borderWidth: PropTypes.number,
		color: PropTypes.string,
		trackColor: PropTypes.string,
		style: PropTypes.object,
	};

	static defaultProps = {
		borderWidth: 2,
		size: 20,
		style: {},
		centered: false,
		color: Colors.blue,
		trackColor: "rgba(0, 0, 0, 0.2)",
	};

	render() {
		const { size, style, borderWidth, color, trackColor, centered } = this.props;

		const spinner = (
			<div
				style={{ width: size, height: size, ...style }}
				className={`${css.cpSpinner} cp-spinner`}
				data-testid="spinner"
			>
				<div
					style={{
						width: size - borderWidth * 2,
						height: size - borderWidth * 2,
						borderColor: trackColor,
						borderLeftColor: color,
						borderWidth,
					}}
					className={`${css.quarterCircle} quarter-circle`}
				/>
			</div>
		);

		if (centered) {
			return <div style={{ textAlign: "center" }}>{spinner}</div>;
		}

		return spinner;
	}
}
